// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";


import { getAuth, signInWithRedirect, GoogleAuthProvider, getRedirectResult, onAuthStateChanged } from "firebase/auth";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDzu7dwAkrc0FEL1PlW-Nm3XkvHKDjG-8E",
  authDomain: "react-chatbot-1f6a5.firebaseapp.com",
  projectId: "react-chatbot-1f6a5",
  storageBucket: "react-chatbot-1f6a5.appspot.com",
  messagingSenderId: "774212760498",
  appId: "1:774212760498:web:530ce94dc15ab64a18eaab"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

//setup auth google
const provider = new GoogleAuthProvider();
const auth = getAuth();

export { app, provider, auth, signInWithRedirect, getRedirectResult, onAuthStateChanged };